import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "14",
  viewBox: "0 0 15 14",
  fill: "none"
}
const _hoisted_2 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'dragIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#B7B7B7",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M14.2386 7.63902C14.5871 7.29047 14.5871 6.76765 14.2386 6.4191L12.4959 4.67636C12.2635 4.444 11.8568 4.32781 11.5664 4.50209C11.2178 4.56018 10.9855 4.90873 10.9855 5.25728V5.95437C10.9855 6.01246 10.9274 6.07055 10.8693 6.07055H8.54564C8.48755 6.07055 8.42946 6.01246 8.42946 5.95437V3.63072C8.42946 3.57263 8.48755 3.51454 8.54564 3.51454H9.24274C9.59129 3.51454 9.93983 3.28217 10.056 2.99172C10.1722 2.64317 10.1141 2.29462 9.88174 2.06225L8.13901 0.319516C7.79046 -0.0290315 7.26764 -0.0290315 6.91909 0.319516L5.17635 2.06225C4.88589 2.29462 4.8278 2.64317 4.94398 2.99172C5.06017 3.28217 5.40871 3.51454 5.75726 3.51454H6.45436C6.51245 3.51454 6.57054 3.57263 6.57054 3.63072V5.95437C6.57054 6.01246 6.51245 6.07055 6.45436 6.07055H4.13071C4.07261 6.07055 4.01452 6.01246 4.01452 5.95437V5.25728C4.01452 4.90873 3.78216 4.56018 3.4917 4.444C3.14315 4.32782 2.79461 4.38591 2.50415 4.61827L0.761411 6.36101C0.412863 6.70956 0.412863 7.23238 0.761411 7.58093L2.50415 9.32366C2.67842 9.49794 2.91079 9.55603 3.14315 9.55603C3.25934 9.55603 3.37552 9.55603 3.4917 9.49794C3.78216 9.43985 4.01452 9.0913 4.01452 8.74275V8.04566C4.01452 7.98757 4.07261 7.92947 4.13071 7.92947H6.45436C6.51245 7.92947 6.57054 7.98757 6.57054 8.04566V10.3693C6.57054 10.4274 6.51245 10.4855 6.45436 10.4855H5.75726C5.40871 10.4855 5.06017 10.7179 4.94398 11.0083C4.8278 11.3569 4.88589 11.7054 5.11826 11.9378L6.861 13.6805C7.20954 14.0291 7.73237 14.0291 8.08091 13.6805L9.82365 11.9378C10.056 11.7054 10.1722 11.2988 9.99792 11.0083C9.93983 10.7179 9.59129 10.4855 9.24274 10.4855H8.54564C8.48755 10.4855 8.42946 10.4274 8.42946 10.3693V8.04566C8.42946 7.98757 8.48755 7.92947 8.54564 7.92947H10.8693C10.9274 7.92947 10.9855 7.98757 10.9855 8.04566V8.74275C10.9855 9.0913 11.2178 9.43985 11.5083 9.55603C11.6245 9.61412 11.7407 9.61412 11.8568 9.61412C12.0892 9.61412 12.3216 9.49794 12.4959 9.38176L14.2386 7.63902Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ]))
}
}

})